// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"e6320ed1","165":"4bf0fcad","262":"a0fedc7b","321":"e2ce0561","357":"394c4e6a","402":"76808fb8","557":"930c9b2b","615":"28697850","639":"54a27444","678":"3a4306c5","729":"d2f79297","953":"d8622e34","957":"4e2225ca","991":"b2af1efe"}[chunkId] + ".chunk.js";
};